/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { QuantityValueType } from './QuantityValueType';
import {
    instanceOfQuantityValueType,
    QuantityValueTypeFromJSON,
    QuantityValueTypeFromJSONTyped,
    QuantityValueTypeToJSON,
} from './QuantityValueType';

/**
 * @type CreateDefinitionParameterDtoValueType
 * 
 * @export
 */
export type CreateDefinitionParameterDtoValueType = QuantityValueType;


export function CreateDefinitionParameterDtoValueTypeFromJSON(json: any): CreateDefinitionParameterDtoValueType {
    return CreateDefinitionParameterDtoValueTypeFromJSONTyped(json, false);
}

export function CreateDefinitionParameterDtoValueTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDefinitionParameterDtoValueType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...QuantityValueTypeFromJSONTyped(json, true) };
    return  QuantityValueTypeFromJSONTyped(json, true);
}

export function CreateDefinitionParameterDtoValueTypeToJSON(value?: CreateDefinitionParameterDtoValueType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfQuantityValueType(value)) {
        return QuantityValueTypeToJSON(value as QuantityValueType);
    }

    return {};
}

/**
 * Check if a given object implements the CreateDefinitionParameterDtoValueType interface.
 */
export function instanceOfCreateDefinitionParameterDtoValueType(value: any): value is CreateDefinitionParameterDtoValueType {
    if (instanceOfQuantityValueType(value)) return true;
    return false;
}

